interface PlaceMapProps {
  latitude: number;
  longitude: number;
  name?: string;
  /** Height in px. The width fills the space it is in. */
  height?: number;
  className?: string;
}

/**
 * A small map with a pin, from OpenStreetMap's own embed (free, and what
 * OpenStreetMap offers for embedding). Used in the host's place editor and in
 * the guest's place sheet. No script of ours runs in it.
 */
export function PlaceMap({ latitude, longitude, name, height = 200, className = '' }: PlaceMapProps) {
  const dLng = 0.004;
  const dLat = 0.0026;
  const bbox = [longitude - dLng, latitude - dLat, longitude + dLng, latitude + dLat].map((n) => n.toFixed(6)).join(',');
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitude.toFixed(6)},${longitude.toFixed(6)}`;
  return (
    <iframe
      title={name ? `Map: ${name}` : 'Map'}
      src={src}
      loading="lazy"
      referrerPolicy="no-referrer"
      sandbox="allow-scripts allow-same-origin"
      style={{ width: '100%', height, border: 0 }}
      className={`block bg-app-bg ${className}`}
    />
  );
}

export default PlaceMap;
